import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "inactive-tag-exists-modal",
  templateUrl: "./inactive-tag-exists-modal.component.html",
})
export class InactiveTagExistsModalComponent {
  @Input()
  public isOpen: boolean;
  @Input()
  public width: number;
  @Output()
  public onClose = new EventEmitter<void>();
  @Output()
  public onActivate = new EventEmitter<void>();

  handleCancel(): void {
    this.onClose.emit();
  }

  handleActivate(): void {
    this.onActivate.emit();
  }
}
